
import React from 'react';
import { InteractiveContentViewer } from './InteractiveContentViewer';

interface TrainingInteractiveContentViewerProps {
  type: 'free_response' | 'drag_drop' | 'linking';
  fileId: string;
  resourceId: string;
  onComplete?: () => void;
  onGameUpdate?: (fileId: string, attempt: any) => Promise<void>;
}

export function TrainingInteractiveContentViewer({
  type,
  fileId,
  resourceId,
  onComplete,
  onGameUpdate
}: TrainingInteractiveContentViewerProps) {
  return (
    <InteractiveContentViewer
      type={type}
      fileId={fileId}
      resourceId={resourceId}
      onComplete={onComplete}
      onGameUpdate={onGameUpdate}
    />
  );
}
